import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export abstract class ShSearchRoutingService {
    public getSearchRouterLink(): string[] {
        return [];
    }
}
